module.exports = __webpack_public_path__ + "img/96eeb6d.png";